import { createContext, useContext, useState } from "react";

const CompareContext = createContext();

export const CompareProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  const addToCompare = (product) => {
    setItems(prev => {
      if (prev.find(p => p.listed_product_id === product.listed_product_id)) return prev;
      if (prev.length >= 4) return prev;
      return [...prev, product];
    });
  };

  const removeFromCompare = (id) => {
    setItems(prev => prev.filter(p => p.listed_product_id !== id));
  };

  const clearCompare = () => setItems([]);

  return (
    <CompareContext.Provider value={{
      items,
      addToCompare,
      removeFromCompare,
      clearCompare
    }}>
      {children}
    </CompareContext.Provider>
  );
};

export const useCompare = () => useContext(CompareContext);